import { z } from 'zod'
import {
  addressPrimitiveSchema,
  lowerHexSchema,
  txHashSchema,
} from './primitive'

export const logSchema = z.object({
  address: addressPrimitiveSchema,
  data: lowerHexSchema,
  logIndex: z.number().int(),
  topics: z.array(lowerHexSchema),
  transactionHash: txHashSchema,
  eventName: z.string().optional(),
  args: z
    .array(
      z.object({
        indexed: z.boolean(),
        name: z.string(),
        type: z.string(),
        value: z.unknown(),
      }),
    )
    .optional(),
})

export type Log = z.infer<typeof logSchema>
